import styled from '@emotion/styled'

export const CreditCardDisplayStyled = styled.strong({
  display: 'inline-flex',

  '& :not(:last-child)': {
    marginRight: '0.5ch',
  },
})
